import {
	NAV_LIST,
	MachineType,
	AG_GAME_CONFIG,
	SLOT_GAME_CONFIG,
	SPORT_GAME_CONFIG,
	LIVE_GAME_CONFIG,
	CHESS_GAME_CONFIG,
	LOTTERY_GAME_CONFIG,
} from '../../utils/constants';
import allgame from '@/data/game.js';
export default {
	namespaced: true,
	state: {
		game: allgame.game, //所有游戏类别数据
		AG_GAME_CONFIG,
		SLOT_GAME_CONFIG,
		SPORT_GAME_CONFIG,
		LIVE_GAME_CONFIG,
		CHESS_GAME_CONFIG,
		LOTTERY_GAME_CONFIG,
		MachineType, //机器类型
		cachePages: [], //页面缓存--暂无作用
	},
	mutations: {
		// setCachePages(state, page) {
		// 	state.cachePages.push(page);
		// },
		// delCachePages(state, length) {
		// 	let start = state.cachePages.length - length;
		// 	if (start > 0) {
		// 		state.cachePages.splice(start, length);
		// 	} else {
		// 		state.cachePages = [];
		// 	}
		// },
		// clearCachePages(state) {
		// 	state.cachePages = [];
		// },
		setGame(state, game) {
			state.game = game;
		},
	},
	actions: {
	},
	getters: {
		game: state => {
			return state.game;
		},
	},
};
